import { DestinationTaskConfigBase } from '../config-objects/destination-service-config-base';

/** Source array key for line items. */
export const LINE_ITEMS_ARRAY_KEY = 'lineItems.__array';
/** Source array key for invoice addresses. */
export const INVOICE_ADDRESSES_ARRAY_KEY = 'invoiceAddresses.__array';
/** Source array key for contact addresses. */
export const CONTACT_ADDRESSES_ARRAY_KEY = 'contact.addresses.__array';
/** Source array key for contact phone numbers. */
export const CONTACT_PHONES_ARRAY_KEY = 'contact.phones.__array';
/** Source array key for contact persons. */
export const CONTACT_PERSONS_ARRAY_KEY = 'contact.contactPersons.__array';

/** All recognised array-source mapping keys. */
export const XERO_ARRAY_KEYS = new Set<string>([
	LINE_ITEMS_ARRAY_KEY,
	INVOICE_ADDRESSES_ARRAY_KEY,
	CONTACT_ADDRESSES_ARRAY_KEY,
	CONTACT_PHONES_ARRAY_KEY,
	CONTACT_PERSONS_ARRAY_KEY,
]);

export enum ValueSource {
	processingData,
	contextData,
	flowVariable,
}

export enum XeroAuthType {
	CustomConnection,
	WebApp,
}

export interface XeroMappingData {
	useStaticValue?: boolean;
	fieldPath: string;
	fieldValue?: string;
	fieldType: ValueSource;
}

/**
 * Configuration for a XeroCreateInvoice task.
 *
 * Mappings uses dotted-path keys:
 *   - `"type"`, `"date"`, etc.          → Invoice base fields
 *   - `"contact.name"`, etc.            → Contact fields
 *   - `LINE_ITEMS_ARRAY_KEY`            → Source array path for line items
 *   - `"lineItems.description"`, etc.   → Line item fields within each array element
 */
export class XeroCreateInvoiceConfig extends DestinationTaskConfigBase {
	authType: XeroAuthType = XeroAuthType.CustomConnection;

	/** Xero client ID. Can be an expression. CustomConnection auth only. */
	clientID = '';
	/** Xero client secret. Stored as a passphrase. CustomConnection auth only. */
	clientSecret = '';

	/** Selected `OAuthConnectionConfig.id` (provider=Xero). WebApp auth only. */
	connectionID = '';
	/** Selected tenant from the connection's authorized `tenants[]`. WebApp auth only. */
	tenantID = '';

	constructor(init?: Partial<XeroCreateInvoiceConfig>) {
		super(init);
		if (init) {
			Object.assign(this, init);
		}
	}

	mappings: { [key: string]: XeroMappingData } = {};
}
